import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { Div, P } from '../../Styled';
import { cssByBreakpoint, flex, hoverMultiple, SPACINGS } from '../../../styling';
import { LeftChevron } from '../../svg';
import { COLORS, TYPOGRAPHY } from '../../../themes';
import HLink from '../../links/HLink';
var Wrapper = /*#__PURE__*/styled(Div).withConfig({
  displayName: "Breadcrumb__Wrapper",
  componentId: "sc-5o51wc-0"
})(["", " ", ""], cssByBreakpoint([css(["", " div:not(:first-child):not(.ellipsis):not(:last-child){display:none;}", ""], flex('flex-start'), function (_ref) {
  var numberOfLevels = _ref.numberOfLevels;
  return numberOfLevels <= 2 && "\n          div:not(:last-child):after {\n            content: '/';\n            margin: 0 ".concat(SPACINGS.S, "px;\n            ").concat(TYPOGRAPHY.M, "\n            color: ").concat(COLORS.NEUTRAL_250, ";\n          }");
}), css(["", ""], function (_ref2) {
  var numberOfLevels = _ref2.numberOfLevels;
  return numberOfLevels <= 3 && "\n          div:not(:first-child):not(.ellipsis):not(:last-child) {\n            ".concat(flex('flex-start'), "\n          }\n\n          .ellipsis {\n            display: none;\n          }\n\n          div:not(:last-child):after {\n            content: '/';\n            margin: 0 ").concat(SPACINGS.S, "px;\n            ").concat(TYPOGRAPHY.S, "\n            color: ").concat(COLORS.NEUTRAL_250, ";\n          }");
})]), function (_ref3) {
  var $css = _ref3.$css;
  return $css;
});
var linkOrButtonCss = cssByBreakpoint([css(["", " ", " ", ""], flex(), TYPOGRAPHY.M, hoverMultiple([{
  prop: 'color',
  base: COLORS.NEUTRAL_400,
  hover: COLORS.PRIMARY_500
}, {
  prop: 'text-decoration',
  base: 'none',
  hover: 'underline'
}])), css(["", " color:", ";"], TYPOGRAPHY.S, COLORS.NEUTRAL_400)]);
var leftChevronCss = cssByBreakpoint([css(["margin-right:26px;"]), css(["display:none;"])]);
var slashCss = cssByBreakpoint([css(["margin:0 ", "px;", " color:", ";"], SPACINGS.S, TYPOGRAPHY.M, COLORS.NEUTRAL_250), css(["", " color:", ";"], TYPOGRAPHY.S, COLORS.NEUTRAL_250)]);
var ellipsisCss = cssByBreakpoint([css(["", " color:", ";"], TYPOGRAPHY.M, COLORS.NEUTRAL_400), css(["", " color:", ";"], TYPOGRAPHY.S, COLORS.NEUTRAL_400)]);

var _ref5 = /*#__PURE__*/React.createElement(Div, {
  $css: slashCss
}, "/");

var _ref6 = /*#__PURE__*/React.createElement(P, {
  $css: ellipsisCss
}, "...");

var _ref7 = /*#__PURE__*/React.createElement(Div, {
  $css: slashCss
}, "/");

var Breadcrumb = function Breadcrumb(_ref4) {
  var $css = _ref4.$css,
      levels = _ref4.levels;
  return /*#__PURE__*/React.createElement(Wrapper, {
    $css: $css,
    numberOfLevels: levels.length
  }, levels.map(function (level, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Div, {
      $css: css(["", ""], flex())
    }, level.href && /*#__PURE__*/React.createElement(HLink, {
      $css: linkOrButtonCss,
      sameTab: true,
      href: level.href
    }, index === 0 && /*#__PURE__*/React.createElement(LeftChevron, {
      $css: leftChevronCss,
      color: COLORS.NEUTRAL_400
    }), level.page), level.to && /*#__PURE__*/React.createElement(HLink, {
      $css: linkOrButtonCss,
      sameTab: true,
      to: level.to
    }, index === 0 && /*#__PURE__*/React.createElement(LeftChevron, {
      $css: leftChevronCss,
      color: COLORS.NEUTRAL_400
    }), level.page)), index === 0 && levels.length > 2 && /*#__PURE__*/React.createElement(Div, {
      className: "ellipsis",
      $css: css(["", ""], flex())
    }, _ref5, _ref6, _ref7));
  }));
};

export default Breadcrumb;